var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "card has-background-dark has-text-light",
      attrs: { id: "search-results" }
    },
    [
      _c("header", { staticClass: "card-header" }, [
        _c("p", { staticClass: "card-header-title has-text-light" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("search.result.title")) + "\n    ")
        ]),
        _c("br"),
        _vm._v(" "),
        _vm.$conf.search.showStatus && _vm.status
          ? _c("small", [
              _vm._v(
                "\n      Updated at: " +
                  _vm._s(_vm.formatDate(_vm.status.date, "DD.MM.YYYY")) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "card-header-icon has-text-light",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                return _vm.$store.dispatch("clearSearch")
              }
            }
          },
          [
            _c(
              "b-tooltip",
              {
                attrs: {
                  label: _vm.$t("search.result.close"),
                  position: "is-left",
                  type: "is-black"
                }
              },
              [_c("b-icon", { attrs: { icon: "close", type: "" } })],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "content" }, [
          _c(
            "ul",
            [
              _vm._l(_vm.columns, function(i) {
                return _vm.result[i]
                  ? _c("li", { key: i }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("search.result.columns." + i)) + ":"
                        )
                      ]),
                      _vm._v(" "),
                      i === "area"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.formatArea(_vm.result[i])))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      i !== "area"
                        ? _c("span", [_vm._v(_vm._s(_vm.result[i]))])
                        : _vm._e()
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.$conf.search.showStatus && _vm.status
                ? _c("li", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("search.result.field.status")) + ":")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class:
                          "tag is-rounded " + _vm.statusIcons[_vm.status.status]
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t(_vm.status.status)))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$conf.search.showEvents && _vm.events
                ? _c("li", [
                    _c("hr"),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("search.result.field.events")) + ":")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      _vm._l(_vm.events, function(evt, i) {
                        return _c(
                          "div",
                          { key: "evt-" + i, staticClass: "event" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formatDate(evt["date"])) +
                                " " +
                                _vm._s(_vm.$t(evt["estimate"])) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer", { staticClass: "card-footer" }, [
        _vm.$conf.chart.enabled
          ? _c(
              "a",
              {
                staticClass: "card-footer-item",
                attrs: { href: "#", title: _vm.$t("chart") },
                on: { click: _vm.openChartModal }
              },
              [
                _c(
                  "span",
                  { staticClass: "has-text-centered" },
                  [
                    _c("b-icon", {
                      attrs: {
                        icon: "chart-areaspline",
                        size: "is-large",
                        type: "is-light"
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("view.chart")) + "\n      "
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$conf.feedback.enabled
          ? _c(
              "a",
              {
                staticClass: "card-footer-item",
                attrs: { href: "#", title: _vm.$t("feedback") },
                on: { click: _vm.openFeedbackModal }
              },
              [
                _c(
                  "span",
                  { staticClass: "has-text-centered" },
                  [
                    _c("b-icon", {
                      attrs: {
                        icon: "alert",
                        size: "is-large",
                        type: "is-light"
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("feedback")) + "\n      "
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }